import tagIdMethods from './Tags.id'
import tagMethods from './Tags'

export const TagServices = {
  ...tagMethods,
  id: tagIdMethods
}

export * from './Tags.types'
